import { type RootState } from '../rmsStore'

export default function getRmsSupportCenterReducer (state: RootState): RmsSupportCenterState {
  return state.rmsSupportCenterReducer
}
